import { apiService } from './index';

export const asyncGetUserLog = async () => {
    return await apiService.get('/api/users/profile');
};
